import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { registrationTaxDetails } from "../../Redux/Actions/sellerAction";

const TaxDetails = ({ onNext }) => {
  const dispatch = useDispatch();
  const [taxDetails, setTaxDetails] = useState("");
  const [sellerLegalName, setSellerLegalName] = useState("");
  const [GSTnmuber, setGSTnmuber] = useState("");
  const [PANnumber, setPANnumber] = useState("");

  const taxRegistrationHandle = () => {
    const sellerTaxRegistrationData = {
      taxDetails: taxDetails,
      sellerLegalName: sellerLegalName,
      GSTnmuber: GSTnmuber,
      PANnumber: PANnumber,
    };

    dispatch(registrationTaxDetails(sellerTaxRegistrationData));
    onNext();
  };
  return (
    <div>
      <div className="w-full md:px-44 md:py-12 py-4">
        <div className="flex md:flex-row flex-col ">
          <div className="form w-full  md:px-12 px-2 mb-3">
            <div className="w-auto  md:mx-auto border rounded-md border-gray-300 shadow-lg px-3 py-3">
              <h1 className="text-md text-amber-500 font-semibold">
                Update your tax details
              </h1>
              {/* i have GSTIN number */}
              <div class="flex items-start mb-2 mt-2">
                <div class="flex items-center h-5">
                  <input
                    id="remember"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 border  border-red-300 rounded-full bg-gray-50  focus:ring-blue-300  "
                    required=""
                  />
                </div>
                <label
                  for="remember"
                  class="ml-2 text-xs font-normal text-gray-900 "
                >
                  I have GSTIN number{" "}
                </label>
              </div>
              <div class="mb-3">
                <label
                  for="taxdetails"
                  class="block mb-1 text-sm font-semibold text-gray-900 "
                >
                  Enter your tax details
                </label>
                <input
                  type="text"
                  id="taxdetails"
                  value={taxDetails}
                  onChange={(e) => setTaxDetails(e.target.value)}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
                  placeholder="ODISHA"
                  required=""
                />
              </div>
              <div class="mb-3">
                <label
                  for="legalname"
                  class="block mb-1 text-sm font-semibold text-gray-900"
                >
                  Seller Legal Name
                </label>
                <input
                  type="text"
                  id="legalname"
                  value={sellerLegalName}
                  onChange={(e) => setSellerLegalName(e.target.value)}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
                  placeholder="chandan prakash samartha"
                  required=""
                />
              </div>
              <div class="mb-3">
                <label
                  for="gstnumber"
                  class="block mb-1 text-sm font-semibold text-gray-900 "
                >
                  GST Number
                </label>
                <input
                  type="textr"
                  id="gstnumber"
                  value={GSTnmuber}
                  onChange={(e) => setGSTnmuber(e.target.value)}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
                  placeholder="123456789"
                  required=""
                />
              </div>
              <div class="mb-3">
                <label
                  for="pannumber"
                  class="block mb-1 text-sm font-semibold text-gray-900 "
                >
                  PAN Number
                </label>
                <
                  input
                  type="text"
                  id="pannumber"
                  value={PANnumber}
                  onChange={(e) => setPANnumber(e.target.value)}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
                  placeholder="OHMP123094"
                  required=""
                />
              </div>

              {/* I don't have GSTIN number */}
              <div class="flex items-start mb-2 mt-2">
                <div class="flex items-center h-5">
                  <input
                    id="gstin1"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 border  border-red-300 rounded-full bg-gray-50  focus:ring-blue-300  "
                    required=""
                  />
                </div>
                <label
                  for="gstin1"
                  class="ml-2 text-xs font-normal text-gray-900 "
                >
                  I do not have GSTIN number{" "}
                </label>
              </div>
              <button
                onClick={taxRegistrationHandle}
                class="text-white bg-amber-500 hover:bg-amber-500/90 border shadow-sm   focus:outline-none font-medium rounded-sm text-sm w-full  px-5 py-2 mt-2 text-center "
              >
                Next
              </button>
            </div>
          </div>
          <div className="FAQ w-full   md:px-6 px-2">
            <div className="w-full h-full border border-gray-300 shadow-sm py-3 px-3">
              <h1 className="text-lg font-bold text-amber-400 mb-4">FAQ</h1>
              <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                <button className="text-left">
                  {" "}
                  I don't have GSTIN registration number. What can i do?
                </button>
              </h1>
              <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                <button className="text-left">
                  {" "}
                  I have a composite GSTIN, can i sell on Apna App ?
                </button>
              </h1>
              <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                <button className="text-left">
                  {" "}
                  Isell goods which are exempted from GST. Do i still need to
                  apply for GSTIN certificate?
                </button>
              </h1>
              <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                <button className="text-left">
                  {" "}
                  where will my GSTIN information be used ?
                </button>
              </h1>
              <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                <button className="text-left">
                  {" "}
                  Why is my PAN/GSTIN non-editable ?{" "}
                </button>
              </h1>
              <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                <button className="text-left">
                  {" "}
                  Which PAN should i enter ?
                </button>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxDetails;
